import { Project } from '@raystack/frontier';

import { createOptimizedContext } from '@src/contexts/createOptimizedContext';

interface ProjectsContext {
  lastSelectedProjectId: string;
  projects: Project[];
}

export const {
  Provider: ProjectsProvider,
  useStoreSelector: useProjectsSelector,
  useStoreDispatch: useProjectsDispatch
} = createOptimizedContext<ProjectsContext>({
  lastSelectedProjectId: '',
  projects: []
});
